module.exports = __webpack_public_path__ + "static/media/main.a7523a9b.png";